// 쇼링 입고 스캔 (실물 파이프라인 PL-2, 2026-07-11) — shoring role, 모바일 우선.
//   VIN 스캔/입력 → 매칭(exact/오탈자 후보/walk-in) → 입고 확정 → 쇼링 완료 처리.
//   백엔드: routes/shoringIntakes.js. ShoringPortal 과 별도 화면 (기존 사진 업로드는 ShoringPortal 유지).
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import CustomModal from './CustomModal';

var NAVY = '#1B3A5C';
var IN_LABEL = { arrived: '입고됨', shored: '쇼링 완료', released: '출고됨' };
var IN_COLOR = { arrived: '#2563eb', shored: '#16a34a', released: '#94a3b8' };

function ShoringIntake({ showToast }) {
  var st = showToast || function () {};
  var vinState = useState(''); var vin = vinState[0]; var setVin = vinState[1];
  var scanState = useState(null); var scan = scanState[0]; var setScan = scanState[1];
  var locState = useState(''); var loc = locState[0]; var setLoc = locState[1];
  var listState = useState([]); var list = listState[0]; var setList = listState[1];
  var expectedState = useState([]); var expected = expectedState[0]; var setExpected = expectedState[1];
  var busyState = useState(false); var busy = busyState[0]; var setBusy = busyState[1];
  var modalState = useState(null); var modal = modalState[0]; var setModal = modalState[1];
  var closeModal = function () { setModal(null); };

  function loadList() { authFetch(API + '/shoring/intakes').then(function (r) { return r.json(); }).then(function (d) { if (d && d.success) setList(d.items || []); else st('목록 로드 실패', 'err'); }).catch(function () { st('목록 로드 실패', 'err'); }); }
  function loadExpected() { authFetch(API + '/shoring/intakes/expected').then(function (r) { return r.json(); }).then(function (d) { if (d && d.success) setExpected(d.items || []); }).catch(function () {}); }
  useEffect(function () { loadList(); loadExpected(); }, []);

  function doScan() {
    if (!vin.trim()) { st('VIN 을 입력하세요', 'err'); return; }
    setBusy(true); setScan(null);
    authFetch(API + '/shoring/intakes/scan', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ vin: vin }) })
      .then(function (r) { return r.json(); })
      .then(function (d) { setBusy(false); if (d && d.success) setScan(d); else st((d && d.error) || '스캔 실패', 'err'); })
      .catch(function () { setBusy(false); st('스캔 실패', 'err'); });
  }
  function confirmIntake(car, dispatchItemId) {
    setBusy(true);
    authFetch(API + '/shoring/intakes', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ vin: vin, carId: car.car_id, dispatchItemId: dispatchItemId || 0, locationText: loc })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        setBusy(false);
        if (d && d.success) { st('입고 완료' + (d.corrected ? ' (VIN 오탈자 보정 기록됨)' : ''), ''); setVin(''); setLoc(''); setScan(null); loadList(); loadExpected(); }
        else st((d && d.error) || '입고 실패', 'err');
      })
      .catch(function () { setBusy(false); st('입고 실패', 'err'); });
  }
  function setStatus(it, status) {
    if (busy) return;
    // 네이티브 confirm 대신 공용 CustomModal (앱 모달 체계 통일 — 2026-07-14 V게이트 발견)
    if (status === 'shored' && !it.__confirmed) {
      setModal({ type: 'confirm', title: it.carNo + ' 쇼링 작업 완료로 처리할까요?', confirmText: '쇼링 완료', onConfirm: function () { closeModal(); setStatus(Object.assign({}, it, { __confirmed: true }), status); } });
      return;
    }
    setBusy(true);
    authFetch(API + '/shoring/intakes/' + it.id + '/status', { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ status: status }) })
      .then(function (r) { return r.json(); }).then(function (d) { setBusy(false); if (d && d.success) { st('처리됨', ''); loadList(); } else st((d && d.error) || '실패', 'err'); }).catch(function () { setBusy(false); st('실패', 'err'); });
  }

  function carLine(c) {
    return <span><b style={{ color: NAVY }}>{c.carNo}</b><span style={{ fontSize: 12, color: '#64748b', marginLeft: 6 }}>{(c.carType || '') + (c.color ? ' · ' + c.color : '')}</span><span style={{ fontSize: 11, color: '#94a3b8', marginLeft: 6 }}>{c.vin}</span></span>;
  }

  return (
    <div style={{ padding: '16px 14px', maxWidth: 720, margin: '0 auto' }}>
      <div style={{ fontSize: 20, fontWeight: 800, color: NAVY, marginBottom: 2 }}>{'📥 입고 스캔'}</div>
      <div style={{ fontSize: 12, color: '#64748b', marginBottom: 12 }}>{'도착 차량의 VIN 을 입력하면 배차 예정 차량과 자동 매칭됩니다 (입고 예정 ' + expected.length + '대)'}</div>

      {/* 스캔 입력 */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: 14, marginBottom: 14 }}>
        <div style={{ display: 'flex', gap: 8 }}>
          <input value={vin} onChange={function (e) { setVin(e.target.value); }} onKeyDown={function (e) { if (e.key === 'Enter') doScan(); }}
            placeholder="VIN (차대번호) 입력" style={{ flex: 1, padding: '12px 12px', borderRadius: 8, border: '1px solid #cbd5e1', fontSize: 15, boxSizing: 'border-box', textTransform: 'uppercase' }} />
          <button onClick={doScan} disabled={busy} style={{ padding: '12px 20px', background: NAVY, color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>{'매칭'}</button>
        </div>
        <input value={loc} onChange={function (e) { setLoc(e.target.value); }} placeholder="야드 위치 메모 (선택 — 예: A열 3번)" style={{ width: '100%', marginTop: 8, padding: '10px 12px', borderRadius: 8, border: '1px solid #e5e7eb', fontSize: 13, boxSizing: 'border-box' }} />

        {/* 매칭 결과 */}
        {scan && scan.match === 'exact' && (
          <div style={{ marginTop: 10, padding: 12, background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 10 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#15803d', marginBottom: 6 }}>{'✅ 배차 차량 일치 (' + (scan.car.dispatch_no || '') + ')'}</div>
            <div style={{ marginBottom: 8 }}>{carLine(scan.car)}</div>
            <button onClick={function () { confirmIntake(scan.car, scan.dispatchItemId); }} disabled={busy} style={{ width: '100%', padding: '12px', background: '#16a34a', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 800, cursor: 'pointer' }}>{'입고 확정'}</button>
          </div>
        )}
        {scan && scan.match === 'candidates' && (
          <div style={{ marginTop: 10, padding: 12, background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 10 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#b45309', marginBottom: 6 }}>{'⚠️ 정확 일치 없음 — 유사 VIN 후보 (오탈자 확인)'}</div>
            {scan.candidates.map(function (c) {
              return (
                <div key={c.car_id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #fef3c7' }}>
                  <div>{carLine(c)}<span style={{ fontSize: 11, color: '#b45309', marginLeft: 6 }}>{'차이 ' + c.editDistance + '자'}</span></div>
                  <button onClick={function () { confirmIntake(c, c.dispatch_item_id); }} disabled={busy} style={{ padding: '8px 14px', background: NAVY, color: '#fff', border: 'none', borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>{'이 차량으로 입고'}</button>
                </div>
              );
            })}
          </div>
        )}
        {scan && scan.match === 'walkin' && (
          <div style={{ marginTop: 10, padding: 12, background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 10 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#1d4ed8', marginBottom: 6 }}>{'ℹ️ 배차 예정에 없는 차량 — 자가 입고(walk-in) 처리'}</div>
            <div style={{ marginBottom: 8 }}>{carLine(scan.car)}</div>
            <button onClick={function () { confirmIntake(scan.car, 0); }} disabled={busy} style={{ width: '100%', padding: '12px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 800, cursor: 'pointer' }}>{'자가 입고 확정'}</button>
          </div>
        )}
        {scan && scan.match === 'none' && (
          <div style={{ marginTop: 10, padding: 12, background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 10, fontSize: 13, color: '#dc2626', fontWeight: 600 }}>
            {scan.error || '❌ 매칭되는 차량이 없습니다 — VIN 을 다시 확인하세요'}
          </div>
        )}
      </div>

      {/* 입고 목록 */}
      <div style={{ fontSize: 14, fontWeight: 800, color: NAVY, marginBottom: 6 }}>{'입고 현황'}</div>
      {list.length === 0 && <div style={{ padding: 30, textAlign: 'center', color: '#94a3b8', background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12 }}>{'입고 기록이 없습니다'}</div>}
      {list.map(function (it) {
        return (
          <div key={it.id} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: '10px 14px', marginBottom: 8, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
            <div>
              {carLine({ carNo: it.carNo, carType: it.carType, color: it.color, vin: it.vin })}
              <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>
                {(it.dispatch_item_id ? '배차 입고' : '자가 입고') + (it.location_text ? ' · 📍 ' + it.location_text : '') + ' · 사진 ' + (it.shoringPhotoCount || 0) + '장' + (it.createdAt ? ' · ' + it.createdAt : '')}
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <span style={{ fontSize: 11, fontWeight: 700, color: '#fff', background: IN_COLOR[it.status] || '#94a3b8', borderRadius: 10, padding: '3px 10px' }}>{IN_LABEL[it.status] || it.status}</span>
              {it.status === 'arrived' && <button onClick={function () { setStatus(it, 'shored'); }} disabled={busy} style={{ padding: '8px 12px', background: '#16a34a', color: '#fff', border: 'none', borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>{'쇼링 완료'}</button>}
            </div>
          </div>
        );
      })}
      {modal && <CustomModal isOpen={true} {...modal} onCancel={closeModal} />}
    </div>
  );
}

export default ShoringIntake;
